import type { FC } from 'react';

// types
import styles from './EmailSignatureSpanButton.module.scss';

const EmailSignatureSpanButton: FC<
  React.PropsWithChildren<{
    onActivate: () => void;
  }>
> = ({ onActivate, children }) => {
  return (
    // This component needs to be a span instead of a button because
    // it will need to be placed under the accordion header, which is
    // another button, nested buttons are not semantically correct
    <span
      onClick={(event: React.MouseEvent<HTMLSpanElement>) => {
        event.stopPropagation();
        onActivate();
      }}
      onKeyDown={(event: React.KeyboardEvent) => {
        event.stopPropagation();
        if (event.key === 'Enter') {
          event.preventDefault();
          onActivate();
        } else if (event.key === ' ') {
          event.preventDefault();
        }
      }}
      onKeyUp={(event: React.KeyboardEvent) => {
        if (event.key === ' ') {
          event.preventDefault();
          onActivate();
        }
      }}
      role="button"
      tabIndex={0}
      className={styles['em-sig-clickable-action-icon']}
    >
      {children}
    </span>
  );
};

export default EmailSignatureSpanButton;
